import styled from 'styled-components';

export const RowStyledTwo = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`;

export const ContentStyled = styled.div`
  padding: 20px 24px 24px;
  width: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 768px) {
    padding: 20px 10px 10px;
    height: calc(100vh - 174px);
  }
`;
